// @noflow
export class NewTimer {
  constructor(airing, timerPreferences, channelInfo) {
    this.modelType = 'NewTimer';

    this._airing = airing.modelType === 'AiringEventListing' ? airing._airing : airing;
    this._timerPreferences = timerPreferences || {};
    this._channelInfo = channelInfo;

    this.creator = 0; // make getter when creator is implemented
    this.timerType = 3; // Default value for API
    this.timerAttributes = 0; // Default value for API
  }

  // *****************************
  //    GET VALUES FROM AIRING
  // *****************************

  get channel() {
    if (this._airing.channel) return this._airing.channel;
    if (this._channelInfo) return this._channelInfo.channel;
    if (this._airing.channel_information) return this._airing.channel_information.channel;
    if (this._airing.channelInformation) return this._airing.channelInformation.channel;

    // Sports airing:
    if (this._airing.is_sports && this._airing.channel_number) return this._airing.channel_number;
    // Austin JS recordings
    if (this._airing.service_id) return this._airing.service_id;
    // Guide airings can have either but channel is preferred:
    return this._airing.channel || this._airing.service_unique_id;
    // || other locations...
    // Radish should continue devving this.
    // Channel should ideally be in the same location for every airing.
    // Channel and ServiceId are not interchangable.
  }

  get startTime() {
    if (this._airing.start_date_time) return this._airing.start_date_time;
    if (this._airing.start_time) return this._airing.start_time;
    return 'No Start Time Found';
  }

  get duration() {
    if (this._airing.run_time) return Number(this._airing.run_time) / 60;
    if (this._airing.duration) return this._airing.duration;
    return this._airing.runtime / 60;
  }

  get upid() {
    return this._airing.upid;
  }

  get channelName() {
    if (this._channelInfo) {
      if (this._channelInfo.svc_name) return this._channelInfo.svc_name;
      if (this._channelInfo.callsign) return this._channelInfo.callsign;
    }

    if (this._airing.channel_callsign) return this._airing.channel_callsign;
    if (this._airing.callsign) return this._airing.callsign;
    if (this._airing.svc_name) return this._airing.svc_name;
    if (this._airing.channel_name) return this._airing.channel_name;

    if (this._airing.channel_information) return this._airing.channel_information.callsign;
    if (this._airing.channelInformation) return this._airing.channelInformation.callsign;

    return 'No Channel Name/Callsign Found';
  }

  get programName() {
    if (this._airing.name) return decodeURIComponent(this._airing.name);
    if (this._airing.program_name) return decodeURIComponent(this._airing.program_name);
    if (this._airing.program_title) return decodeURIComponent(this._airing.program_title);
    if (this._airing.event_name) return decodeURIComponent(this._airing.event_name);
    return 'No Program Name Found';
  }

  // ********************************
  // GET VALUES FROM TIMERPREFERENCES
  // ********************************

  get priority() {
    return this._timerPreferences.priority;
  }

  get frequency() {
    return this._timerPreferences.frequency;
  }

  get minutesEarly() {
    return this._timerPreferences.startEarly;
  }

  get minutesLate() {
    return this._timerPreferences.endLate;
  }

  get eventCount() {
    return this._timerPreferences.maxRecordings;
  }
}

export default NewTimer;
